export const ALLOWED_HTML_TAGS = [
  'a',
  'blockquote',
  'br',
  'code',
  'div',
  'em',
  'h1',
  'h2',
  'h3',
  'img',
  'li',
  'ol',
  'p',
  'pre',
  'span',
  'strong',
  'table',
  'tbody',
  'td',
  'th',
  'thead',
  'tr',
  'u',
  'ul',
];

export const ALLOWED_HTML_ATTRS = [
  'alt',
  'colspan',
  'height',
  'href',
  'rel',
  'rowspan',
  'src',
  'target',
  'title',
  'width',
];

export const FORBID_HTML_TAGS = [
  'button',
  'embed',
  'form',
  'iframe',
  'input',
  'link',
  'math',
  'meta',
  'object',
  'script',
  'select',
  'style',
  'svg',
  'textarea',
];

export const ALLOWED_TAG_SET = new Set(ALLOWED_HTML_TAGS);
export const ALLOWED_ATTR_SET = new Set(ALLOWED_HTML_ATTRS);
export const FORBID_TAG_SET = new Set(FORBID_HTML_TAGS);
